String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

function resizeBackground() {
  
  var image_width          = 1280,
      image_height         = 1024,
      image_ratio          = image_width/image_height,
      browser_actual_width = $(window).width(),
      browser_width        = $(window).width() > 940 ? $(window).width() : 940,
      browser_height       = $(window).height(),
      browser_ratio        = browser_width/browser_height,
      half_height          = -parseInt(browser_width/(image_ratio*2), 10),
      half_width           = -parseInt((browser_height*image_ratio)/2, 10);

  if(browser_ratio > image_ratio){
  	// this is when the width is 100% and centered vertically
  	$('.bg_stretch').css({
  		'marginTop': 0,
  		'marginLeft':'auto',
  		'top':'0',
  		'left':'0', 
  		'width':browser_actual_width < 940 ? '940px':'100%',
  		'height':'auto',
  		'display':'block'
  		});
  }else{
  	// this is when the height is 100% and centered horizontally
  	$('.bg_stretch').css({
  		'marginTop': '0',
  		'marginLeft':half_width,
  		'top':'0',
  		'left':'50%',
  		'width':'auto',
  		'height':'100%',
  		'display':'block'
  		});
  } 
}




$(function() {
  
  resizeBackground();
  
  $(window).on( 'resize', resizeBackground );
    
  if ( $('.test-page').length ) {
        
    $('.page-content').append( $('html').attr('class') );
    
    for ( o in $.browser ) {
      $('.page-content').append( '<br />browser: ' + o + ' = ' + $.browser[o]);
    }
  }
  
      
  var path   = window.location.pathname,
  
  // Pages
  home       = $('.homepage-collections'), // Home
  blog       = $('.blog-content'), // Blog
  page       = $('.page-content'), // Page
  collection = $('.collection-products'), // Collection
  product    = $('.product-info'), // Product
  cart       = $('.cart-page'),
  
  // Current page's background image.
  bg = $('.site-background').text();
  
  $.backstretch(bg, {
    centeredX: false,
    centeredY: false
  });
  
  if ( blog.length ) {
    
    $('.blog-post a').on( 'click', function(e) {
      e.preventDefault();
      window.open( $(this).attr('href') );
    });
    
    $('.next a').text('Next');
    $('.prev a').text('Previous');
  }
  
  if ( cart.length ) {
    
    var prechange = '/cart/change',
        postchange = '?quantity=';
        
    if ( $('.cart-item-link').length ) {
      $.get($('.cart-item-link').first().attr('href'), function (data) {
        url = $(data).find('.product-meta a').attr('href');
        
        // $('.back-button').attr('href', url)
        //   .html('Back to ' + $('.cart-item-link').first().text());
      });
    }
        
    $('.add-one').on( 'click', function() {
      
      var id = $(this).parents('.product-in-cart').data('id'),
          quant = parseInt($(this).siblings('.item-quantity').text(), 10) + 1;
          
      
      //console.log(prechange + id + postchange + (parseInt(quant, 10) + 1));
      //console.log(quant)
 
      $.ajax({
  		type: "POST",
  		url: "/cart/change.js",
  		data: { quantity: quant, id: id }
	  });
      //window.location.reload();
      //$.post( "/cart/change.js", { quantity: quant, id: id }).done(function( data ) {
  		//window.location.reload();
	  //});
      //$.post(
      setTimeout(function(){
        window.location.reload();
       
      //	window.location.replace(prechange + id + postchange + (parseInt(quant, 10) + 1));
      }, 500);
    });
    
    $('.remove-one').on( 'click', function() {
      
      var id = $(this).parents('.product-in-cart').data('id'),
          quant = parseInt($(this).siblings('.item-quantity').text(), 10) - 1;
      
	 
      $.ajax({
  		type: "POST",
  		url: "/cart/change.js",
  		data: { quantity: quant, id: id }
	  });
      setTimeout(function(){
        window.location.reload();
       
      //	window.location.replace(prechange + id + postchange + (parseInt(quant, 10) + 1));
      }, 500);
      
    });
    
  }
  
  if ( home.length ) {
    
    var $prods = $('.home-product'),
        types = [],
        
        opts = {
          lines: 8, // The number of lines to draw
          length: 1, // The length of each line
          width: 4, // The line thickness
          radius: 9, // The radius of the inner circle
          color: '#30adef', // #rgb or #rrggbb
          speed: 2.2, // Rounds per second
          trail: 100, // Afterglow percentage
          shadow: false // Whether to render a shadow
        },
        target = document.getElementById('loader'),
        spinner = new Spinner(opts).spin(target),
        i,
        _len,
        hash = window.location.hash.replace('#', '');
        
    $('.mobile body').css('min-height', '1200px');
    
    $(spinner.el).css('left', '0')
        
    for ( var i = 0, _len = $prods.length; i < _len; i++ ) {
      var text = $prods[i].innerHTML;
      if ( $.inArray(text, types) == -1 ) {
        types.push(text);
      } 
    }
    
    $(types).each( function( index, el ) {
      home.append('<li class="product-types" data-type="' + el + '"><h1>&mdash;' + el + '</h1></li>');
    });
    
    $('.product-types').each( function() {
      
      var $this        = $(this),
          type         = $this.data('type'),
          $products    = $('[data-product-type=' + type + ']'),
          $collections = $products.parents('.collection').data('collection'),
          items        = '',
          counter      = 0,
          collections  = {},
          i, _len;

      for ( i = 0, _len = $products.length; i < _len; i++ ) {

        var $p = $($products[i]),
            $c = $p.parents('.collection'),

            prod = {},

            c_title = $c.data('collection-title'),
            c_link = $c.data('collection-link'),
            p_title = $p.data('product-title'),
            p_link = $p.data('product-link'),
            p_img = $p.data('product-img');

        if ( collections[c_title] == undefined ) {
          collections[c_title] = {
            title: c_title,
            link: c_link,
            products: []
          }
        }

        prod = {
          title: p_title,
          link: p_link,
          img: p_img
        }

        collections[c_title].products.push( prod );

      } // for

      for ( collection in collections ) {
        
        var coll = collections[collection].link.replace('/collections/', '');
        
        items += '<span class="collection-title invisible" data-coll="' + coll + '"><h1><a href="' + collections[collection].link + '">' + collections[collection].title + '</a></h1></span>';

        $.each( collections[collection].products, function( i, e ) {
          items += '<span class="invisible" data-coll="prod-' + coll + '"><a href="' + e.link +'"><img src="' + e.img + '" /></a></span>';
        });

      } // for
      
      $('.item-list').css('display', 'none');
      
      // if ( $.browser.safari ) {
      //   $('.collection-title h1').css('line-height', '86px');
      // }
      
      $this.append( '<span class="item-list">' + items + '</span>' );

    });
    
    // Remove loading, show menus.
    $('img').imagesLoaded( function() {
      
      $(spinner.el).stop();
      $('#loader').hide();
      $('.blog-content').show();
      $('.homepage-collections').show();
      
      $('.item-list').css('display', 'block');
      
      $.each( $('.item-list span'), function( i, e ) {
        var $e = $(e),
            w  = $e.width();
            
        $e.data('size', w).css('width', 0).removeClass('invisible');
      });
      
      $('span[data-coll="prod-' + hash + '"]').first().parents('.product-types').find('h1').trigger('click', true);
      
    });
    
    $('.product-types').on( 'click', 'h1', function(event, quick) {
      
      if (quick) {
        var speed = 0;
      } else {
        var speed = 400;
      }
            
      $('.global-logo').attr('href', '/').off('mouseover').find('h1').attr('style', '');
      
      var $this = $(this),
          $spans = $this.siblings('.item-list').find('span');
            
      $this.parent().siblings().find('.item-list span').animate({
        'width'     : '0'
      }, function() {
        $this.parent().siblings().children('h1').removeClass('showing').fadeIn();
      });
      
      $this.not('.collection-title h1').fadeOut(speed, function() {
        $spans.each( function( i, el ) {
          size = $(this).data('size')
          
          if ($('body').hasClass('safari')) {
            if ($(el).hasClass('.collection-title')) {
              size = parseInt(size * 1.10, 10)
            }
          }
          $(el).animate({
            'width': size
          }, { queue: false, duration: speed });

        })
      });
      
    });
        
    $('[data-coll]').on( 'mouseover', function() {
      
      var $this = $(this),
          data  = $this.data('coll');
      
      if ( data.indexOf('prod') !== -1 ) {
        $('[data-coll="' + data.replace('prod-', '') + '"]').find('a').css('font-weight', '700');
      } else {
        $('[data-coll="prod-' + data + '"]').find('a').css('border-color', '#30adef');
      }
      
    });
    
    $('[data-coll]').on( 'mouseout', function() {
      
      var $this = $(this),
          data = $this.data('coll');
          
      if ( data.indexOf('prod') !== -1 ) {
        $('[data-coll="' + data.replace('prod-', '') + '"]').find('a').css('font-weight', '400');
      } else {
        $('[data-coll="prod-' + data + '"]').find('a').css('border-color', 'transparent');
      }
      
    });
    
    $('.global-logo').on( 'mouseover', function() {
      
      var attr = $(this).attr('href');
      
      if ( attr !== '/' ) {
        $(this).find('h1').attr('style', '').css('font-weight', '400 !important');
      }
      
    });
    
    
    
    
    
  } // home
    
  // Test if we're on a product page
  if ( product.length ) {
    
    $('body').click(function(){$('.next').click()});
    
    var $images   = $('.product-images li'),
        $prev     = $('.prev'),
        $next     = $('.next'),
        $current  = $('.current'),
        $total    = $('.total'),
        count     = $current.text() - 1,
        $lis      = $('.collection-products li'),
        $products = $('.collection-products a'),
        pagetitle = $('.product-collection-title a').text(),
        title     = $('.product-title').text().replace(/"/g, "&quot;"),
        index     = $('a[title="' + title + '"]').attr('class').replace('product-', '');
    
    // preload images

	$images.each(function(index, li){$('<img/>')[0].src = $(li).text()})
        
    if ( window.location.hash === '#last' ) {

      $.backstretch( $images.last().text() );
      count = $images.length - 1;
      $current.text( count + 1 );
    
    } else if ( $.isNumeric( window.location.hash.replace('#', '') ) ) {
      
      var num = window.location.hash.replace('#', '');
      
      if ( num > $images.length ) {
        num = $images.length;
        window.location.hash = num;
      }
      
      $.backstretch( $images.eq(num - 1).text() );
      count = num - 1;
      $current.text( count + 1 );
      
    } else {
      $.backstretch( $images.first().text() );
    }
    
    $('#product-select').on( 'change', function() {
      var $this = $(this),
          text = $('.selectedTxt').text(),
          sel = $this.find('option:contains(' + text + ')').val(),
          price = $('.' + sel).find('span').text();
      
      $('.product-price').text( price );    
      
    });
    
    $total.text( $images.length );
    
    $next.on( 'click', function() {
      
      if ( count == $images.length - 1 ) {
        
        if ( parseInt(index) === $lis.length ) {
          window.location.href = $('.product-1').attr('href');
        } else {
          window.location.href = $('.product-' + (parseInt(index) + 1)).attr('href');
        }
        
      } else {
        count++;
        $current.text( count + 1 );
      }
      
      window.location.hash = count + 1;
      $.backstretch( $images.eq(count).text() );
      return false;
    });
    
    $prev.on( 'click', function() {
      
      if ( count < 1 ) {
        
        if ( index == 1 ) {
          window.location.href = $('.product-' + $products.length).attr('href') + '#last';
        } else {
          window.location.href = $('.product-' + (parseInt(index) - 1)).attr('href') + '#last';
        }
         
      } else {
        count--;
        $current.text( count + 1 );
      }
      
      window.location.hash = count + 1;
      $.backstretch( $images.eq(count).text() );
      return false;     
    });
    
  } // product
  
  
  
  
});